export default defineNuxtRouteMiddleware((to) => {
  const { $localePath } = useNuxtApp()
  if (to.query.uid && to.query.event) return navigateTo($localePath('/'))
})
